import React from "react";
import Link from "next/link";
import { Anchor, Box, Text } from "@govlaunch/web";
import { FormattedMessage } from "react-intl";

interface ISignInSwitchLinkProps {
  signIn?: boolean;
  mt?: number | string | number[] | string[];
  color?: string;
}

export default function SignInSwitchLink({ signIn = false, color, mt }: ISignInSwitchLinkProps) {
  if (signIn) {
    return (
      <Box mt={mt}>
        <Text fontSize="md" fontWeight="normal" lineHeight="21px" color={color ? color : "#828282"}>
          <FormattedMessage defaultMessage="Not a member?" id="Ruds26" />{" "}
          <Link href="/signup" as="/signup" passHref={true} legacyBehavior={true}>
            <Anchor>
              <Text textDecoration="underline" color={color ? color : undefined} as="span">
                <FormattedMessage defaultMessage="Sign up for free" id="Rtxm5T" />
              </Text>
            </Anchor>
          </Link>
        </Text>
      </Box>
    );
  }

  return (
    <Box mt={mt}>
      <Text fontSize="md" fontWeight="normal" lineHeight="21px" color={color ? color : "#828282"}>
        <FormattedMessage defaultMessage="Already a member?" id="F0ft6o" />{" "}
        <Link href="/signin" as="/signin" passHref={true} legacyBehavior={true}>
          <Anchor>
            <Text textDecoration="underline" color={color ? color : undefined} as="span">
              <FormattedMessage defaultMessage="Sign In" id="Ub+AGc" />
            </Text>
          </Anchor>
        </Link>
      </Text>
    </Box>
  );
}
